/* eslint-disable no-unused-vars */
export enum OperationStatus {
  DONE = 'DONE',
  ERROR = 'ERROR',
  IN_PROGRESS = 'IN_PROGRESS',
}
